<template>
  <ol class="breadcrumb pull-right">
    <li class="breadcrumb-item">
      <router-link tag="a" :to="'/'">首页</router-link>
    </li>
    <li class="breadcrumb-item" v-for="(item,index) in breadcrumbItem" :key="index">
      <router-link tag="a" :to="item.to">{{item.name}}</router-link>
    </li>
    <li class="breadcrumb-item active">{{activeName}}</li>
  </ol>
</template>
<script>
export default {
  props: ["activeName", "breadcrumbItem"]
};
</script>


